// Static menu, locations and brand constants for Old Soul Pizzeria
export const BRAND = {
  name: "Old Soul Pizzeria",
  tagline: "100 years of soul, 90 seconds on fire",
  phone: "942-444-7423",
  phoneHref: "tel:+19424447423",
  email: "hello@oldsoulpizzeria.com",
  emailHref: "mailto:hello@oldsoulpizzeria.com",
  instagram: "@OLDSOULPIZZERIA",
  instagramUrl: "https://instagram.com/oldsoulpizzeria",
  address: "1940 Lawrence Avenue East, Scarborough, ON",
  mapsUrl: "https://www.google.com/maps?q=1940+Lawrence+Ave+E,+Scarborough,+ON",
};

export const MENU = [
  {
    id: "signature-red",
    title: "Signature Red",
    subtitle: "San Marzano tomato base",
    items: [
      { name: "Marinara", price: 12.49, desc: "San Marzano tomato base, garlic & Pecorino Romano" },
      { name: "Bella Marinara", price: 17.49, desc: "San Marzano tomato base, minced garlic, fresh basil, Pecorino Romano, oregano and fresh burrata" },
      { name: "Margherita", price: 13.99, desc: "San Marzano tomato base, Fior di Latte, fresh basil & Pecorino Romano (add fresh burrata for 3.99)" },
      { name: "Drunken Tomato", price: 15.99, desc: "Velvety vodka sauce, mozzarella, aromatic oregano, bocconcini & ricotta (add extra hot honey drizzle for 0.99)" },
      { name: "Caprino", price: 16.49, desc: "San Marzano tomato base, mozzarella, roasted red pepper, goat cheese and pesto drizzle" },
      { name: "Arugula Amore", price: 15.99, desc: "San Marzano tomato base, Fior di Latte, minced onion, Kalamata olives, arugula & Pecorino Romano" },
      { name: "Paneer Speziato Al Gorno", price: 17.49, desc: "Signature house sauce base, marinated cottage cheese, minced onion, roasted red pepper & mozzarella" },
      { name: "Vegan Edition", price: 16.49, desc: "San Marzano tomato base, vegan cheese, vegan sausage, hot honey & minced onions" },
      { name: "Devil's Drizzle", price: 15.99, desc: "San Marzano tomato base topped with bocconcini & fiery Calabrian chili, creamy ricotta & hot honey drizzle" },
    ],
  },
  {
    id: "signature-green",
    title: "Signature Green",
    subtitle: "House-made basil pesto base",
    items: [
      { name: "Pesto Melanzana", price: 13.99, desc: "Pesto base, mozzarella, grilled eggplant, minced red onion, cherry tomatoes & feta cheese" },
      { name: "Pesto Al Pomodoro", price: 14.99, desc: "Pesto base, cherry tomatoes, arugula, bocconcini & balsamic drizzle" },
    ],
  },
  {
    id: "signature-white",
    title: "Signature White",
    subtitle: "Signature white sauce base",
    items: [
      { name: "Tartufata", price: 16.49, desc: "Signature white sauce, shiitake, cremini & white mushroom, Fior di Latte & a drizzle of truffle oil" },
      { name: "Five Cheese Melt Down", price: 17.99, desc: "Signature white sauce, molten five-cheese blend of fresh bocconcini, Fior di Latte, mozzarella, cheddar & Pecorino Romano" },
    ],
  },
  {
    id: "infused-oil",
    title: "Infused Oil Based",
    subtitle: "Fragrant herb-infused olive oil",
    items: [
      { name: "Spina-Bella", price: 14.99, desc: "Rosemary infused olive oil, baby spinach, cherry tomatoes, ricotta & feta cheese" },
      { name: "Carciofi Piccanti", price: 15.49, desc: "Garlic infused olive oil, roasted red pepper, grilled artichoke, red chili flakes & bocconcini" },
      { name: "Salt & Spud", price: 14.99, desc: "Fragrant rosemary-infused olive oil base, thinly sliced potatoes & a sprinkle of sea salt" },
    ],
  },
  {
    id: "specials-sides",
    title: "Specials & Sides",
    subtitle: "Beyond the pizza",
    items: [
      { name: "Old Soul Salad", price: 8.99, desc: "Crispy orecchiette, iceberg lettuce, cherry tomatoes, house sauce & Pecorino Romano" },
      { name: "Old Soul Sandwich", price: 12.49, desc: "Red pesto sauce, vine tomatoes, basil, arugula, chili garlic butter & fresh burrata" },
      { name: "Old Soul Garlic Crust", price: 9.99, desc: "Roasted garlic butter crust, Pecorino Romano, oregano & mozzarella" },
      { name: "Old Soul Dipping Sauce", price: 2.29, desc: "A velvety blend of savory garlic with bright, fresh green garlic" },
      { name: "Customise & Make Your Own", price: 11.99, desc: "Start with a sourdough base and build your own with our toppings & finishers" },
    ],
  },
  {
    id: "desserts-drinks",
    title: "Desserts & Drinks",
    subtitle: "Sweet endings",
    items: [
      { name: "Old Soul Tiramisu", price: 11.49, desc: "Espresso-soaked ladyfingers layered with velvety mascarpone & cocoa dust" },
      { name: "Pop", price: 1.99, desc: "Assorted soft drinks" },
      { name: "Water", price: 1.49, desc: "Bottled water" },
    ],
  },
];

export const ADDONS = [
  { name: "Vegan Cheese", price: 0, note: "Substitute for free" },
  { name: "Toppings", price: 1.49 },
  { name: "Mozzarella", price: 1.99 },
  { name: "Fior di Latte", price: 2.99 },
  { name: "Fresh Burrata", price: 5.49 },
  { name: "Hot Honey Drizzle", price: 1.99 },
  { name: "Pesto Drizzle", price: 1.99 },
  { name: "Truffle Oil Drizzle", price: 1.99 },
  { name: "Chili Garlic Butter Glaze", price: 1.49 },
];

export const SCHEDULE = [];

export const HOURS = [
  { day: "Monday – Thursday", hours: "4:00 PM – 12:00 AM" },
  { day: "Friday – Saturday", hours: "4:00 PM – 12:00 AM" },
  { day: "Sunday", hours: "4:00 PM – 12:00 AM" },
];

// User-uploaded pizza photography (verified — watermark-free where possible)
export const PIZZA_PHOTOS = {
  margherita: "https://customer-assets.emergentagent.com/job_vegan-pizza-cart/artifacts/zonatst5_WhatsApp%20Image%202026-06-06%20at%208.21.59%20PM.jpeg",
  caprino: "https://customer-assets.emergentagent.com/job_vegan-pizza-cart/artifacts/vkxv3x9j_WhatsApp%20Image%202026-06-09%20at%208.37.46%20PM.jpeg",
  tartufata: "https://customer-assets.emergentagent.com/job_vegan-pizza-cart/artifacts/cxlhyedr_image.png",
  tiramisu: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?auto=format&fit=crop&w=900&q=80",
};

export const GALLERY = [
  // Big hero — multi-pizza flat lay (user's own)
  { url: "https://customer-assets.emergentagent.com/job_vegan-pizza-cart/artifacts/01msaj45_WhatsApp%20Image%202026-06-09%20at%209.14.45%20PM.jpeg", alt: "A spread of Old Soul pizzas on marble", span: "lg", crop: "center" },
  // Closeup of margherita on marble (Unsplash editorial)
  { url: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?auto=format&fit=crop&w=1200&q=80", alt: "Wood-fire margherita pizza", span: "sm", crop: "center" },
  // User's caprino (single copy)
  { url: PIZZA_PHOTOS.caprino, alt: "Caprino with roasted red pepper & pesto drizzle", span: "sm", crop: "top" },
  // User's tartufata clean PNG
  { url: PIZZA_PHOTOS.tartufata, alt: "Tartufata — white mushroom & truffle", span: "md", crop: "center" },
  // Wood-fire oven flames
  { url: "https://images.unsplash.com/photo-1571066811602-716837d681de?auto=format&fit=crop&w=1200&q=80", alt: "Wood-fired pizza oven flames", span: "sm", crop: "center" },
  // Better tiramisu
  { url: "https://images.pexels.com/photos/6880219/pexels-photo-6880219.jpeg?auto=compress&cs=tinysrgb&w=900", alt: "Tiramisu with cocoa dust", span: "sm", crop: "center" },
  // Hands holding a sourdough pizza
  { url: "https://images.unsplash.com/photo-1604068549290-dea0e4a305ca?auto=format&fit=crop&w=900&q=80", alt: "Hands holding a sourdough pizza", span: "md", crop: "center" },
];
